/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuthIdRequest,
  CreateEmergencyRequest,
  EmergencyFullData,
  EmergencyIdRequest,
  EmergencyOnAzure,
  EmergencySafeguardDelete,
  EmergencySelfSetChatOpened,
  UserHistoryOnAzure,
} from '../models/index';
import {
    AuthIdRequestFromJSON,
    AuthIdRequestToJSON,
    CreateEmergencyRequestFromJSON,
    CreateEmergencyRequestToJSON,
    EmergencyFullDataFromJSON,
    EmergencyFullDataToJSON,
    EmergencyIdRequestFromJSON,
    EmergencyIdRequestToJSON,
    EmergencyOnAzureFromJSON,
    EmergencyOnAzureToJSON,
    EmergencySafeguardDeleteFromJSON,
    EmergencySafeguardDeleteToJSON,
    EmergencySelfSetChatOpenedFromJSON,
    EmergencySelfSetChatOpenedToJSON,
    UserHistoryOnAzureFromJSON,
    UserHistoryOnAzureToJSON,
} from '../models/index';

export interface ApiEmergencyAddPostRequest {
    createEmergencyRequest?: CreateEmergencyRequest;
}

export interface ApiEmergencyDeleteAllObjectsDeleteRequest {
    emergencySafeguardDelete?: EmergencySafeguardDelete;
}

export interface ApiEmergencyGetAllByIdV1GetRequest {
    emergencyId?: string;
}

export interface ApiEmergencyGetEmergencyHistoryByAuthIdPostRequest {
    authIdRequest?: AuthIdRequest;
}

export interface ApiEmergencyResolveV1PutRequest {
    emergencyIdRequest?: EmergencyIdRequest;
}

export interface ApiEmergencySetChatOpenedPutRequest {
    emergencySelfSetChatOpened?: EmergencySelfSetChatOpened;
}

/**
 * 
 */
export class EmergencyApi extends runtime.BaseAPI {

    /**
     */
    async apiEmergencyAddPostRaw(requestParameters: ApiEmergencyAddPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmergencyOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Emergency/Add`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateEmergencyRequestToJSON(requestParameters['createEmergencyRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmergencyOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiEmergencyAddPost(requestParameters: ApiEmergencyAddPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmergencyOnAzure> {
        const response = await this.apiEmergencyAddPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiEmergencyDeleteAllObjectsDeleteRaw(requestParameters: ApiEmergencyDeleteAllObjectsDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Emergency/DeleteAllObjects`;

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: EmergencySafeguardDeleteToJSON(requestParameters['emergencySafeguardDelete']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiEmergencyDeleteAllObjectsDelete(requestParameters: ApiEmergencyDeleteAllObjectsDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiEmergencyDeleteAllObjectsDeleteRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiEmergencyGetAllByIdV1GetRaw(requestParameters: ApiEmergencyGetAllByIdV1GetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmergencyFullData>> {
        const queryParameters: any = {};

        if (requestParameters['emergencyId'] != null) {
            queryParameters['emergency_id'] = requestParameters['emergencyId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Emergency/GetAllById_v1`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmergencyFullDataFromJSON(jsonValue));
    }

    /**
     */
    async apiEmergencyGetAllByIdV1Get(requestParameters: ApiEmergencyGetAllByIdV1GetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmergencyFullData> {
        const response = await this.apiEmergencyGetAllByIdV1GetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiEmergencyGetEmergencyHistoryByAuthIdPostRaw(requestParameters: ApiEmergencyGetEmergencyHistoryByAuthIdPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserHistoryOnAzure>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Emergency/GetEmergencyHistoryByAuthId`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AuthIdRequestToJSON(requestParameters['authIdRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserHistoryOnAzureFromJSON(jsonValue));
    }

    /**
     */
    async apiEmergencyGetEmergencyHistoryByAuthIdPost(requestParameters: ApiEmergencyGetEmergencyHistoryByAuthIdPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserHistoryOnAzure> {
        const response = await this.apiEmergencyGetEmergencyHistoryByAuthIdPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiEmergencyResolveV1PutRaw(requestParameters: ApiEmergencyResolveV1PutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<EmergencyFullData>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Emergency/Resolve_v1`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EmergencyIdRequestToJSON(requestParameters['emergencyIdRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => EmergencyFullDataFromJSON(jsonValue));
    }

    /**
     */
    async apiEmergencyResolveV1Put(requestParameters: ApiEmergencyResolveV1PutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<EmergencyFullData> {
        const response = await this.apiEmergencyResolveV1PutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async apiEmergencySetChatOpenedPutRaw(requestParameters: ApiEmergencySetChatOpenedPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Emergency/SetChatOpened`;

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: EmergencySelfSetChatOpenedToJSON(requestParameters['emergencySelfSetChatOpened']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiEmergencySetChatOpenedPut(requestParameters: ApiEmergencySetChatOpenedPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiEmergencySetChatOpenedPutRaw(requestParameters, initOverrides);
    }

    /**
     */
    async apiEmergencySmsWebhookPostRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        let urlPath = `/api/Emergency/SmsWebhook`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async apiEmergencySmsWebhookPost(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.apiEmergencySmsWebhookPostRaw(initOverrides);
    }

}
